export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register.result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.setting': '设置',
  'menu.setting.sys-settings': '系统设置',
  'menu.setting.sys-settings.org-mng': '部门管理',
  'menu.setting.sys-settings.role-mng': '角色管理',
  'menu.setting.sys-settings.role-add': '角色管理',
  'menu.setting.sys-settings.user-mng': '员工管理',
  'menu.service.customer': '客户管理',
  'menu.service.customer.label-mng': '标签管理',
  'menu.service.customer.level-mng': '等级管理',
  'menu.service.customer.team-mng': '团队管理',
  'menu.service.customer.my-customer': '服务客户',
  // 'menu.service.customer.org-customer': '机构客户',
  'menu.service.customer.public-customer': '潜在客户',
  'menu.service.customer.satisfaction': '服务评价记录',
  'menu.service.customer.add-customer': '创建会员档案',
  'menu.service.customer.customer-detail': '客户详情',
  'menu.service.customer.customer-report-detail': '体检报告',
  'menu.service.customer.customer-package': '服务配置',
  'menu.service.customer.message-board': '留言管理',
  'menu.service': '服务管理',
  'menu.service.package-manage': '服务套餐',
  'menu.service.package-add': '服务套餐管理',
  'menu.service.services': '服务项目',
  'menu.service.service-update': '服务项目更新',
  'menu.service.bind-records': '绑定记录',
  'menu.service.record-create': '添加服务记录',
  'menu.service.task': '任务视图',
  'menu.service.task.task-view-1': '我处理的',
  'menu.service.task.task-view-2': '我创建的',
  'menu.service.task.task-view-3': '我转交的',
  'menu.service.task.task-view-4': '我客户的',
  'menu.service.task.task-view-5': '所有任务',
  'menu.service.task.create-task': '创建任务',
  'menu.service.task.task-process': '处理任务',
  'menu.service.task.task-process-detail': '任务详情',
  'menu.service.task.task-print': '任务打印',
  'menu.assessment': '健康评估',
  'menu.assessment.assessment-records': '评估记录',
  'menu.assessment.assessment-report-mental-detail': '心理健康',
  'menu.assessment.assessment-report-physique-detail': '体质辨识',
  'menu.assessment.assessment-report-risk-detail': '健康风险',
  'menu.shopping': '店铺管理',
  'menu.shopping.promotion': '促销活动',
  'menu.shopping.promotion-add': '添加活动',
  'menu.shopping.order-manage': '商城订单',
  'menu.shopping.order-form': '预约订单',
  'menu.shopping.detail-list': '订单详情',
  'menu.shopping.promote-order': '推广订单',
  'menu.shopping.commodity-manger': '商品管理',
  'menu.shopping.item-controller': '预约项目管理',
  'menu.shopping.category-manger': '商品类目设置',
  'menu.shopping.order-category-controller': '预约类目设置',
  'menu.shopping.commodity-options': '创建商品',
  'menu.shopping.category-addEdit': '创建预约项目',
  'menu.shopping.mall-shop': '店铺设置',
  'menu.shopping.mall-create': '店铺编辑',
  'menu.shopping.mall-freight': '运费模板',
  // 'menu.order-administrate': '预约管理',
  'menu.online-inquiry': '在线咨询',
  'menu.online-inquiry.inquiry-history': '咨询历史',
  'menu.online-inquiry.inquiry-schedule': '排班设置',
  'menu.operation.content': '知识库',
  'menu.operation.content.content-intervention': '干预方案模板',
  'menu.operation.content.add-intervention': '干预方案模板详情',
  'menu.operation.content.content-medicine': '药品库',
  'menu.operation.content.service-plan': '服务方案模板',
  'menu.operation.content.add-service-plan': '服务方案模板详情',
  'menu.operation.content.sms-template': '短信模板库',
  'menu.operation.content.return-visit': '回访话术库',
  'menu.operation.content.add-return-visit': '回访话术详情',
  'menu.operation.content.sport-plan': '运动库',
  'menu.operation.content.add-sport-plan': '运动方案模板详情',
  'menu.operation.content.content-food': '膳食库',
  'menu.operation.content.add-food-plan': '配餐方案详情',
  'menu.operation': '运营管理',
  'menu.operation.operation-information': '健康资讯',
  'menu.operation.operation-MicroMedicalOrders': '微医订单',
  'menu.operation.microMedicalOrders-detail': '微医订单详情',
  'menu.operation.add-information': '健康资讯详情',
  'menu.statistics': '统计分析',
  'menu.statistics.service': '健管服务分析',
  'menu.statistics.customer': '客户分析',
  'menu.operation.equipment': '设备管理',
  'menu.operation.equipment.equipment-view': '设备视图',
  'menu.operation.equipment.equipment-register': '设备登记',
  'menu.operation.equipment.registration-list': '设备登记清单',
  'menu.operation.equipment.equipment-detail': '设备详情页',
  'menu.healthHut': '健康小屋',
  'menu.healthHut.equipment-hut': '小屋检测记录',
  'menu.healthHut.hut-manage': '健康小屋管理',
  'menu.healthHut.add-hut': '添加健康小屋',
  'menu.physicalManage': '体检管理',
  'menu.physicalManage.reportList': '体检报告',
  'menu.physicalManage.reportUpload': '导入新报告',
  'menu.healthHut.test-report': '健康小屋报告',
  'menu.healthHut.zhaiker': '宅客',
  'menu.sms': '短信管理',
  'menu.sms.sms-query': '短信查询',
  'menu.sms.group-message': '短信群发',
  'menu.sms.group-record': '群发记录查询',
  'menu.sys-notice': '系统通知',
  'menu.sys-notice.sys-announcement': '系统公告',
  'menu.sys-notice.sys-notification': '系统通知',
  'menu.publicAccount': '公众号消息',
  'menu.publicAccount.publicAccount-message': '公众号消息',
  'menu.operate.new': '新增',
  'menu.operate.edit': '编辑',
  'menu.operate.copy': '复制',
  'menu.operate.view': '查看',
  'menu.operate.add': '添加',
  'menu.operate.enable': '启用',
  'menu.operate.disable': '禁用',
  'menu.operate.delete': '删除',
  'menu.confirmTitle.delete': '确认删除吗？',

  'menu.status.zero': '未开始',
  'menu.status.one': '进行中',
  'menu.status.two': '已结束',
  'menu.status.three': '已禁用',
  'menu.level.zero': '理想',
  'menu.level.one': '轻度',
  'menu.level.two': '中度',
  'menu.level.three': '偏重',
  'menu.level.four': '严重',
  'menu.time.one': '正常',
  'menu.time.two': '即将过期',
  'menu.time.three': '已过期',
  'menu.time.four': '已取消',
  'menu.report.data': '数据报告',
  'menu.report.images': '图片报告',
  'menu.report.pdf': 'PDF报告',
  'menu.report.manual': 'Excel报告',
  'menu.record.one': '门诊记录',
  'menu.record.two': '急诊记录',
  'menu.record.three': '手术记录',
  'menu.medicine.one': '服药中',
  'menu.medicine.two': '已停药',
  'menu.medicine.three': '未开始',
}
